import { render, staticRenderFns } from "./ModifyAdmission.vue?vue&type=template&id=7c5c500e&"
import script from "./ModifyAdmission.vue?vue&type=script&lang=js&"
export * from "./ModifyAdmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports